import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  active: boolean;
  onClick: () => void;
};

export const FilterButton = ({ active, onClick }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();

  return (
    <Button
      aria-label={t('Filter')}
      iconName='filter-alt'
      hoverLabel={t('Filter')}
      color='light'
      onClick={onClick}
      trackingId={`${trackingIdPrefix}-filter-btn`}
      variant='tertiary'
      size='large'
      css={{
        padding: theme.spacing(1),
        '&::after': {
          content: "''",
          position: 'absolute',
          background: theme.colors.primary50,
          border: `2px solid ${theme.colors.white}`,
          height: '14px',
          width: '14px',
          borderRadius: '14px',
          top: '6px',
          left: '24px',
          opacity: active ? 1 : 0,
        },
      }}
    />
  );
};
